<template>
    <div class="login-mobile-banner">
        <div class="auth-layout__container login-mobile-header">
            <img
                src="@/assets/icons/logo-big-white.svg"
                class="logo"
                @click="goToLandingPage"
            />
        </div>

        <LoginBanner />
    </div>

    <div class="auth-layout__container">
        <div class="login__content">
            <LoginForm />

            <LoginBanner class="login-desktop" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useRouter } from 'vue-router';

    import LoginBanner from '@/views/auth/login/components/LoginBanner/LoginBanner.vue';
    import LoginForm from '@/views/auth/login/components/LoginForm/LoginForm.vue';

    const router = useRouter();

    function goToLandingPage(): void {
        router.push({ path: '/' });
    }
</script>

<style lang="scss">
    @use './Login.scss' as *;
</style>
